import { ProgressCircle, type ProgressCircleRootProps } from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface Props extends ProgressCircleRootProps {
  isIndeterminate?: boolean
}

export default forwardRef<HTMLDivElement, Props>(({ isIndeterminate, value, ...rest }, ref) => {
  return (
    <ProgressCircle.Root
      colorPalette="primary"
      ref={ref}
      value={isIndeterminate ? null : value}
      {...rest}
    >
      <ProgressCircle.Circle css={{ '--thickness': '4px' }}>
        <ProgressCircle.Track />
        <ProgressCircle.Range strokeLinecap="round" />
      </ProgressCircle.Circle>
    </ProgressCircle.Root>
  )
})
